var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('SideMenu'),_c('Header',{attrs:{"title":"Содержание и статистика","theme":"white"}}),(_vm.statsTree)?_c('div',{staticClass:"main-content"},[_c('ul',{staticClass:"stats"},_vm._l((_vm.statsTree),function(item,key){return _c('ProgressItem',{key:key,attrs:{"item":item,"mobile":_vm.mobile}})}),1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }